// extracted by mini-css-extract-plugin
export default {"section_body":"Tabs_section_body__3wKeY","tab_buttons":"Tabs_tab_buttons__Ti7So","button":"Tabs_button__w57Zu","active":"Tabs_active__P8zNM"};